export type FunnelMode = 'full' | 'kcal';

/**
 * Interpreta el parámetro de URL `?checkout=` que fuerza el acceso al checkout.
 * Devuelve `true`/`false` cuando el valor es reconocible, o `undefined` cuando
 * no viene (o trae un valor no reconocido) para caer al default global.
 *
 * Acepta varias grafías cómodas para construir enlaces de marketing:
 *   compra:      ?checkout=1 | true | on | yes | si | sí
 *   informativo: ?checkout=0 | false | off | no
 */
export function parseCheckoutParam(search: string): boolean | undefined {
  const raw = new URLSearchParams(search || '').get('checkout');
  if (raw === null) return undefined;
  const value = raw.trim().toLowerCase();
  if (['1', 'true', 'on', 'yes', 'si', 'sí'].includes(value)) return true;
  if (['0', 'false', 'off', 'no'].includes(value)) return false;
  return undefined;
}

/**
 * Resuelve el modo del funnel:
 * - `/calorias` → siempre 'kcal' (ruta informativa dedicada; la URL no la sube).
 * - Si la URL trae `?checkout=`, MANDA sobre el default global ("la URL manda"):
 *   `?checkout=1` → 'full' (compra) aunque el flag global esté apagado;
 *   `?checkout=0` → 'kcal' (informativo) aunque el flag global esté encendido.
 * - Si la URL no dice nada, se usa `full_funnel_enabled` como default.
 *
 * Nota: el freno duro de "no vender ahora" NO vive aquí, sino en el backend
 * (checkout_paused / maintenance / prestashop_checkout_enabled), que gana a
 * cualquier URL. Este seam solo decide qué pantallas ve el visitante.
 */
export function resolveFunnelMode(pathname: string, fullFunnelEnabled: boolean | undefined, search = ''): FunnelMode {
  if (pathname.startsWith('/calorias')) return 'kcal';
  const override = parseCheckoutParam(search);
  const allowCheckout = override ?? fullFunnelEnabled === true;
  return allowCheckout ? 'full' : 'kcal';
}
